// @ts-nocheck
import { Plugin } from '/data1/gitlab-runner/builds/C83doUmU/0/bluevision/ka_admin_web/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','request',],
});

export { plugin };
